export const SET_DARK_TITLEBAR_CONTENT = 'SET_DARK_TITLEBAR_CONTENT';
export const HIDE_ACTION_BUTTON = 'HIDE_ACTION_BUTTON';
export const SET_DARK_TITLE_CURRENT_CASE = 'SET_DARK_TITLE_CURRENT_CASE';
export const UPDATE_DARK_TITLE_BAR_CASE_STATUS = 'UPDATE_DARK_TITLE_BAR_CASE_STATUS';
export const SHOW_DARK_TITLE_BAR_ACTION_MODAL = 'SHOW_DARK_TITLE_BAR_ACTION_MODAL';
export const HIDE_DARK_TITLE_BAR_ACTION_MODAL = 'HIDE_DARK_TITLE_BAR_ACTION_MODAL';
export const SET_LANGUAGE ='SET_LANGUAGE';
export const SET_TRANSLATED_DATA ='SET_TRANSLATED_DATA';
export const SET_LANGUAGE_FLAG ='SET_LANGUAGE_FLAG';
export const SET_HEADER_DATA ='SET_HEADER_DATA';
export const SET_FOOTER_DATA='SET_FOOTER_DATA';
export const SET_INCORRECT_CUSTOMER='SET_INCORRECT_CUSTOMER';
export const RESET_INCORRECT_CUSTOMER='RESET_INCORRECT_CUSTOMER';
export const SET_DARK_FLAG_PSWD='SET_DARK_FLAG_PSWD';



// WEBPACK FOOTER //
// ./src/components/layouts/actions/actionTypes.js